/** A selectable UPS service level (code + human label). */
export interface UpsServiceOption {
    /** UPS Service.Code value. */
    code: string;
    label: string;
}

/**
 * UPS domestic service levels the shipping team picks between. "Red" = Next Day
 * Air, "Blue" = 2nd Day Air, "Orange" = 3 Day Select in UPS's old color shorthand.
 * Ground is the default for most parcels.
 */
export const UPS_SERVICE_OPTIONS: UpsServiceOption[] = [
    { code: '03', label: 'Ground' },
    { code: '12', label: '3 Day Select' },
    { code: '02', label: '2nd Day Air (Blue)' },
    { code: '59', label: '2nd Day Air A.M.' },
    { code: '13', label: 'Next Day Air Saver' },
    { code: '01', label: 'Next Day Air (Red)' },
    { code: '14', label: 'Next Day Air Early' },
];

export const UPS_DEFAULT_SERVICE_CODE = '03';

/**
 * The services the company uses most across departments — shown as default rate cards.
 * Ordered cheapest → most expensive by assumption (Ground, 2nd Day Air, Next Day Air
 * Saver, Next Day Air) rather than re-sorting by price after every quote. Other services
 * are reached via the service dropdown.
 */
export const UPS_COMMON_SERVICE_CODES: string[] = ['03', '02', '13', '01'];

/** Lookup a service label by code (falls back to the code). */
export function upsServiceLabel(code: string): string {
    return UPS_SERVICE_OPTIONS.find(s => s.code === code)?.label ?? code;
}
